export default __webpack_public_path__ + "static/postfinanceoffice-f9272349996aa0b084c66a271fdaa46c.png";